import React, { Component } from 'react'
import { Upload, Tooltip } from 'antd'
import Col from 'react-bootstrap/Col'
import '../../wallet.css'
import '../brlDepRes.css'
import attach from '../../../../images/attach.png'
import { message } from 'antd'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { getCashIn } from '../../../../redux-flow/actions/wallet_brl'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

const { Dragger}  = Upload

const dados = [
    {    
        titulo: "Banco:",
        info: "082 - Banco Topázio"
    },
    {    
        titulo: "Nome:",
        info: "Phi Serviços de Pagamento S.A"
    },
    {    
        titulo: "CNPJ:",
        info: "31.752.308/0001-17"
    },
    {    
        titulo: "Agência:",
        info: "0001"
    },
    {    
        titulo: "Conta:",
        info: "2060570-5"
    },
    
]

class Depositar extends Component {
    constructor(props) {
    super(props)
    this.state = {
        file: null
    }}

    beforeUpload = file => {
        this.setState({
            file
        })
        return false
    }
        render() {
            const { handleSubmit, cashSubmit, cashSuccess, cashInMessage, userid, comprovante } = this.props
            return (
    
                <>                 
                    <div>
                        {!cashSuccess && cashInMessage ? 
                            <div class="alert alert-danger text-center" role="alert">
                                {cashInMessage}
                            </div> : '' }
                        {cashSuccess && cashInMessage ? 
                            <div class="alert alert-success text-center" role="alert">
                                {cashInMessage}
                            </div> : '' }
                            <Col md={12}>
                                <label className='tituloDados'>Dados para depósito<Tooltip title={`Phi Serviços de Pagamento S.A é o nosso parceiro responsável pela gestão dos depósitos e resgates da ${process.env.REACT_APP_NAME} Wallet. Fique tranquilo, seu saldo está seguro!`} className="ml-2"><FontAwesomeIcon icon={faInfoCircle} /></Tooltip></label>  

                                <label className="tx-grey">Transfira o montante desejado para a conta abaixo para carregar sua conta {process.env.REACT_APP_NAME}. Depois, é só utilizar da maneira que preferir!<br />Caso tenha alguma dúvida, consulte o centro de ajuda.</label>

                                <div className="saldoWrapper d-flex flex-column align-items-center">
                                    <label className="h6 tx-purple mb-0"><b>ATENÇÃO:<br />- O depósito deverá ser realizado através de uma conta da mesma titularidade de sua Flow.in Wallet. <br /><br />- Verifique os dados da conta para transferir corretamente.<br /><br />- Aceitamos depósito apenas através de TED no momento.</b></label>
                                </div>
                                    
                                <div className="mt-5"> 

                                {dados.map (item => (
                                    <div> 
                                        <div className='linhaDados'>
                                            <div><label className='tituloInfoDep'>{item.titulo}</label></div>
                                            <div><label className='infoDep'>{item.info}</label></div>
                                            <div>
                                                <CopyToClipboard text={item.info}
                                                    onCopy={() => message.success('Copiado')}>
                                                    <label className='copiarInfo'>Copiar</label>
                                                </CopyToClipboard> 
                                            </div>                                      
                                        </div>      

                                        <hr className='linhaHorizontal'/>
                                    </div>
                                ))}
                                    
                                </div>

                                <label className="mt-3 tx-grey">O tempo para compensação do saldo em sua conta {process.env.REACT_APP_NAME} é de até 1 dia útil. No momento, o depósito só pode ser feito via TED. Não existe valor mínimo ou máximo para depósito.</label>

                                {/* <div>
                                    <label className='tituloDados mt-5'>Enviar comprovante</label>
                                    <Dragger beforeUpload={this.beforeUpload} onRemove={() => this.setState({ file: '' })} className='draggerBox'>
                                        <label className="tx-pink mb-0"><img alt="Upload" src={attach} className="img-fluid" />Clique ou arraste e solte o arquivo aqui</label>
                                    </Dragger>
                                    {!comprovante && !cashSuccess ? <small style={{color: 'red'}}>Por favor, anexe um arquivo.</small> : ''}
                                </div>

                                { cashSubmit ? 
                                    <div className="mt-3">
                                        <h4 className="tx-pink">Enviando informações...</h4>
                                    </div> 
                                :   <div className="mt-3">
                                        <button onClick={() => handleSubmit(this.state.file, userid)} className="btnSubmit">Enviar</button>
                                    </div> } */}
                            </Col>

                    </div>
                </>
            )
        }
    }

const mapStateToProps = state => ({
    cashSuccess: state.wallet_brl.cashSuccess,
    cashSubmit: state.wallet_brl.cashSubmit,
    cashInMessage: state.wallet_brl.cashInMessage,
    userid: state.login.userid,
    comprovante: state.wallet_brl.comprovante
})
    
const mapDispatchToProps = dispatch => ({
    handleSubmit: (comprovante, userid) => {
        dispatch(getCashIn(comprovante, userid))
    }
})
    
export default connect(mapStateToProps, mapDispatchToProps)(Depositar);
